module.exports = __webpack_public_path__ + "e89ec48698ac073f8eb453fe31630eeb.svg";